const RESET = 'pulp/reportUrl/RESET';

export const initialState = null;

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RESET:
      return action.payload;
    default:
      return state;
  }
}

export function resetReportUrl(payload) {
  return {
    type: RESET,
    payload
  };
}